export const QuoteList = [
    {
        quotetitle: "Lion's Pride",
        quotedate: "11/30/2021",
        quoteID: 1,
        quote: "A lion's pride comes not from its vengeful claws, but from its forgiving heart."
    }, 
    {
        quotetitle: "Failure to Change",
        quotedate: "1/29/2024",
        quoteID: 2,
        quote: "A stone that fails to move with the river of time is doomed to sink."
    },
    {
        quotetitle: "Bridging Forwards",
        quotedate: "8/5/2024",
        quoteID: 3,
        quote: `If you struggle to douse the flames burning the bridges behind you, 
        strive to create new ones to walk forwards.`
    }
]